import { isAuthor, isMobile } from "../../../js/utils";
import { animateObserver, fadeIn, opacityDelayBetweenItems } from "../../../js/animations/animations";
import gsap from "gsap";

(() => {
  "use strict";

  const BRHHeroRoomDetail = () => {
    const roomDetails = document.querySelectorAll(".brh-hero-room-detail");
    roomDetails.forEach((roomDetail) => {
      const slider = roomDetail.querySelector(".brh-hero-room-detail__slider");
      const slides = slider.querySelectorAll(".brh-hero-room-detail__item");
      const slidesCopy = [...slides].map((item) => item.cloneNode(true));
      slidesCopy.forEach((item) => {
        roomDetail.querySelector(".brh-hero-room-detail__slider-thumbs .swiper-wrapper").append(item);
      });
      const swiperThumbs = new window.Swiper(roomDetail.querySelector(".brh-hero-room-detail__slider-thumbs"), {
        slidesPerView: 5,
        spaceBetween: 10,
        freeMode: bcl.u.mobile.isMobile() ? true : false,
        allowTouchMove: bcl.u.mobile.isMobile() ? true : false,
        watchSlidesProgress: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
      });

      new window.Swiper(slider, {
        thumbs: {
          swiper: swiperThumbs,
        },
      });

      const button = roomDetail.querySelector(".js-room-details-modal");
      if (isMobile() && !isAuthor()) {
        button.style.display = "none";
        const hotelDetailCardList = roomDetail.querySelector(".c-hotel-detail__card__list");
        if (hotelDetailCardList) {
          hotelDetailCardList.classList.add("swiper-wrapper");
          [...hotelDetailCardList.children].forEach((item) => {
            item.classList.add("swiper-slide");
          });
          const swiperWrapper = document.createElement("div");
          swiperWrapper.classList.add("brh-hero-room__swiper");
          const clonedContent = hotelDetailCardList.cloneNode(true);
          swiperWrapper.appendChild(clonedContent);
          hotelDetailCardList.parentNode.replaceChild(swiperWrapper, hotelDetailCardList);
        }

        new window.Swiper(roomDetail.querySelector(".brh-hero-room__swiper"), {
          spaceBetween: 20,
          allowTouchMove: true,
          freeMode: true,
          slidesPerView: "auto",
          loop: false,
        });
      }

      if (!isMobile()) {
        const hotelDetailCardList = roomDetail.querySelector(".c-hotel-detail__card__list");
        if (hotelDetailCardList) {
          [...hotelDetailCardList.children].forEach((item, index) => {
            if (index > 11) {
              item.style.display = "none";
            }
          });
        }

        if ([...hotelDetailCardList.children].length < 11) {
          button.style.display = "none";
        }
        button.addEventListener("click", (e) => {
          const modalSection = document.querySelector(".js-brh-modal-section");
          const modalContainer = modalSection.querySelector(".js-brh-modal-container");
          modalContainer.classList.add("mod--color-bronce");
          const modalCloseButton = modalSection.querySelector(".js-btn-close");
          const listIcons = e.target.closest(".brh-hero-room-detail").querySelector(".c-hotel-detail--modal");
          listIcons.classList.remove("hidden");
          const listIconsClone = listIcons.cloneNode(true);

          modalContainer.innerHTML = "";
          modalContainer.appendChild(listIconsClone);
          const hotelDetailCardList = modalContainer.querySelector(".c-hotel-detail__card__list");
          if (hotelDetailCardList) {
            [...hotelDetailCardList.children].forEach((item, index) => {
              if (index > 11) {
                item.style.display = "";
              }
            });
          }

          modalSection.style.display = "block";
          modalSection.parentElement.style.display = "block";
          document.body.classList.add("mod--menu-open");

          if (modalCloseButton) {
            modalCloseButton.addEventListener("click", () => {
              modalContainer.classList.remove("mod--color-bronce");
              listIcons.classList.add("hidden");
            });
          }
        });
      }

      if (!isMobile() && !isAuthor()) {
        const appearances = gsap.timeline();

        const slider = roomDetail.querySelector(".brh-hero-room-detail__slider");
        slider && appearances.add(fadeIn({ classElement: slider, duration: 2 }), 0);
        setTimeout(() => {
          const thumbs = roomDetail.querySelectorAll(".brh-hero-room-detail__slider-thumbs .swiper-slide");
          thumbs.length > 0 && appearances.add(opacityDelayBetweenItems({ classElement: thumbs, duration: 2 }), 0);
        }, 400);

        appearances.pause();

        animateObserver({ elementToObserve: roomDetail, animation: () => appearances, threshold: 0.3 });
      }
    });
  };
  document.addEventListener("DOMContentLoaded", BRHHeroRoomDetail);
})();
